var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._34nMUO1X-SP3Logo-module-sp3-logo{background-image:url(" + escape(require("src/img/logo-sp3.png")) + ");background-size:100% auto;display:inline-block;height:62px;width:91px}", ""]);

// exports
exports.locals = {
	"sp3-logo": "_34nMUO1X-SP3Logo-module-sp3-logo",
	"sp3Logo": "_34nMUO1X-SP3Logo-module-sp3-logo"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/logos/SP3Logo/SP3Logo.module.scss
// module id = 761
// module chunks = 0